export class Validator {

    constructor(settings) {
        this.settings = settings;
    }

    validate(fieldName, value, form = null) {

        const rules = this.settings[fieldName];

        let valid = true;

        for (let rule of rules ?? []) {
            if (rule == 'required' && !value) valid = false;
            if (typeof rule == 'object') {
                if (rule.regexp) {
                    if (rule.check_if_required && form !== null) {
                        const field = form.find(`[name=${fieldName}]`);
                        if ($(field).attr('required') == 'required') {
                            if (value.search(rule.regexp) == -1) valid = false;
                        }
                    } else {
                        if (rule.regexp && value.search(rule.regexp) == -1) valid = false;
                    }
                }
                if (rule.length) {
                    const [min, max] = rule.length;
                    valid = value.length >= min;
                    if (max) valid = valid && value.length <= max;
                }
            }
        }
        if (valid) {
            document.querySelector('form')?.setAttribute('validated', 'yes');
        }
        return valid;
    }
}

export class ValidationError extends Error {

    constructor(data) {
        super('Data format is invalid');
        for (const [fieldName, valid] of Object.entries(data)) {
            const field = document.querySelector(`[name=${fieldName}]`);

            if (!valid) field.style.setProperty('border-color', 'red', 'important');
            else field.style.borderColor = 'black';
        }
        document.querySelector(`form`)?.removeAttribute('validated');
    }
}


